module.exports = __webpack_public_path__ + "img/ph.8f4cafa7.svg";